import { connect } from 'formik';
import { appendValidationClassNames } from './utils';

export const ComponentStyle = ({
  formik: { errors, touched },
  name,
  className,
  render
}) => {
  const classes = appendValidationClassNames(className, touched, errors, name);
  return render(classes);
};

export default connect(ComponentStyle);
